import React from 'react';
import './ReportsNative.css';

/**
 * Tiny semantic status dot (freshness indicator, pace dots in tables).
 *
 * Props:
 *   tone   'success' | 'warning' | 'error' | 'info' | 'neutral'  (default 'success')
 *   size   px diameter (default 7)
 *   halo   soft tinted ring around the dot (default true — mock ".asof .dot")
 *   pulse  slow opacity pulse for "live" states (default false)
 */
export function SemanticDot({ tone = 'success', size = 7, halo = true, pulse = false, className, style, title }) {
  const cls = [
    'rn-dot',
    `rn-dot-${tone}`,
    halo ? `rn-halo-${tone}` : '',
    pulse ? 'rn-pulse' : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');
  return <span className={cls} style={{ width: size, height: size, ...style }} title={title} aria-hidden="true" />;
}

export default SemanticDot;
